import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PaperBasket from "../../components/PaperBasket";
import PaperCard from "../../components/PaperCard";
import {
  fetchGetPastOrders,
  getPastOrders,
} from "../../store/actions/partsActions";
import { Storage } from "aws-amplify";
import "../../styles/containers/PastOrders.scss";
import Loader from "../../components/Loader";
import { Typography } from "@material-ui/core";
import { date } from "yup";
function PastOrders() {
  const [show, setShow] = useState({
    show: false,
    id: null,
    date: null,
    loading: true,
  });
  const users = useSelector((state) => state.users);
  const parts = useSelector((state) => state.parts);
  const { getUser } = users;
  const { getPastOrder, confirmOrder } = parts;
  const [pastBasket, setPastBasket] = useState([]);
  const [pastOrders, setPastOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [headingID, setHeadingID] = useState(null);
  const [allOrders, setAllOrders] = useState([]);
  const [imageLoader, setImageLoader] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setShow({ show: false, id: null, date: null, loading: true });
    dispatch(fetchGetPastOrders());
    setLoading(true);
    setPastBasket([]);
    setPastOrders([]);
  }, []);
  useEffect(() => {
    if (getUser?.user?.park_id) {
      setPastBasket([]);
      setPastOrders([]);
      let data = {
        park_id: parseInt(getUser?.user?.park_id),
      };
      dispatch(getPastOrders(data));
      setShow({ show: false, id: null, date: null, loading: true });
      setLoading(true);
    }
  }, [getUser?.user?.park_id, confirmOrder?.success]);
  useEffect(() => {
    if (
      getPastOrder?.success &&
      getPastOrder?.isFetched &&
      !pastBasket.length &&
      getPastOrder?.orders.length
    ) {
      setLoading(true);

      let orders = getPastOrder?.orders;
      let allArray = [];
      let allUniqueDates = [];
      let allUniqueUser = [];
      orders?.map((order, index) => {
        const { created_at } = order;

        allUniqueDates.push(created_at);

        return null;
      });

      let uniqueFilteredDates = [...new Set(allUniqueDates)];

      setPastBasket((previousData) => {
        let preData = [...previousData];

        let data = uniqueFilteredDates.map((val, index) => {
          let userVal = [];
          orders.filter((order) => {
            if (order.created_at === val) {
              userVal = userVal.concat(` ${order.order_by}`);
            }
          });
          userVal = [...new Set(userVal)];
          return [
            ...preData,
            {
              date: val,
              order_by: userVal,
            },
          ];
        });
        return data;
      });
      uniqueFilteredDates?.filter((date, index) => {
        let arrr = [];
        orders?.map((order, i) => {
          if (order.created_at === date) {
            arrr.push(order);
          }
        });
        allArray.push(arrr);
      });
      setPastOrders(allArray);
      dispatch(fetchGetPastOrders());
      setLoading(false);
    }
  }, [getPastOrder?.isFetched]);
  useEffect(() => {
    if (show.show) {
      setAllOrders([]);
      Promise.all(
        pastOrders.map((val, index) => {
          if (index === show.id) {
            val.map((orders, index) => {
              const {
                id,
                image_url,
                quantity,
                description,
                status,
                created_at,
                order_by,
                park_id,
              } = orders;
              return Storage.get(image_url[0]).then((res) => {
                const data = {
                  description,
                  id,
                  quantity,
                  status,
                  image_url: res,
                  created_at,
                  order_by,
                  park_id,
                };

                setAllOrders((previous) => [...previous, data]);
              });
            });
          }
        })
      ).then(() => {
        setShow({
          ...show,
          loading: false,
        });
      });
    }
  }, [show.show]);

  useEffect(() => {
    if (show.id || show.id === 0)
      setShow({
        ...show,
        show: true,
      });
  }, [show.id]);

  const onClickHeading = (id, date) => {
    setHeadingID(id);
    setShow({ show: !show.show, id, date, loading: true });
  };
  return (
    <div className="pastOrders">
      <h1>Past Orders</h1>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <Loader />
        </div>
      ) : !pastBasket.length ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <Typography variant="h6">There are no Past Orders</Typography>
        </div>
      ) : pastBasket.length ? (
        pastBasket?.map((val, ind) => {
          const [basket] = val;

          const { date, order_by } = basket;
          return (
            <>
              <PaperCard
                heading={date?.split("T")[0]}
                description={order_by}
                backgroundColor="#262626"
                PastOrders={true}
                openPaper={false}
                onClickHeading={() => onClickHeading(ind, date)}
              />
              {ind === show.id && show.show && allOrders.length
                ? allOrders?.map((order, index) => {
                    const {
                      description,
                      id,
                      image_url,
                      quantity,
                      status,
                      order_by,
                      created_at,
                    } = order;

                    return (
                      <PaperBasket
                        desc={description}
                        image={image_url}
                        quantity={quantity}
                        imageLoader={imageLoader}
                        order_by={order_by}
                        created_at={created_at}
                        status={status}
                        PastOrders={true}
                      />
                    );
                  })
                : null}
            </>
          );
        })
      ) : null}
    </div>
  );
}

export default PastOrders;
